// Force CommonJS interop so we’re mutating the *actual* React object
import React = require('react');
const PropTypes = require('prop-types');
const createReactClass = require('create-react-class');

// Polyfill for old React APIs that some libs (react-overlays, react-bootstrap) still call
;(React as any).PropTypes   = PropTypes;
;(React as any).createClass = createReactClass;

// no exports — this file just patches React globally
